import React, { FC } from 'react';

import { EditTwoTone, PlusOutlined } from '@ant-design/icons';
import { Button, Layout, Row, Table, theme, Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';

import { NSKeys } from '@app/i18n';
import { useTableParams } from '@app/services/hooks/useTableParams';
import { Breadcrumbs } from '@components/Breadcrumbs';
import { HeaderTitle } from '@components/HeaderTitle';

import { Paper } from '@components/Paper';

import { useGetCatalogLimitsQuery, useGetCatalogQuery } from '../../hooks';

import { BASE_COLUMNS_WIP } from './constants';

export const Limits: FC = () => {
  const navigate = useNavigate();
  const { token } = theme.useToken();
  const catalogsT = useTranslation(NSKeys.catalogs);
  const commonT = useTranslation(NSKeys.common);
  const { id } = useParams<{ id: string }>();
  const { current, pageSize, setPagination, resetParams } = useTableParams();
  const { data: catalog, isLoading: isCatalogLoading } = useGetCatalogQuery(id || '');
  const { data: catalogLimits, isLoading: isCatalogLimitsLoading } = useGetCatalogLimitsQuery(id || '', {});

  const goBack = () => navigate(`/dashboard/catalogs/${id}`);

  const goEdit = (limitUid: string) => navigate(`/dashboard/catalogs/${id}/limits/${limitUid}/edit`);

  return (
    <Layout>
      <Layout.Header>
        <Breadcrumbs apiTitles={[{ id: ':catalogId', value: catalog?.name }]} />
        <Row justify="space-between" align="middle">
          <HeaderTitle title={catalogsT.t('limits.title')} onClick={goBack} loading={isCatalogLoading} />
          <Button type="primary" icon={<PlusOutlined />} onClick={() => navigate('add')} size="middle">
            {catalogsT.t('limits.addButton')}
          </Button>
        </Row>
      </Layout.Header>
      <Paper style={{ margin: '24px', padding: '16px 24px 24px 24px' }}>
        <Table
          dataSource={catalogLimits?.items}
          rowKey="uid"
          className="tableClassname"
          columns={[
            ...BASE_COLUMNS_WIP.map((el) => ({ ...el, title: catalogsT.t(el.title as any) })),
            {
              key: 'action',
              width: 60,
              fixed: 'right',
              render: (_, row) => (
                <Tooltip title={commonT.t('edit')}>
                  <Button
                    type="link"
                    icon={<EditTwoTone twoToneColor={token.colorPrimary} />}
                    onClick={(e) => {
                      e.stopPropagation();
                      goEdit(row.uid);
                    }}
                  />
                </Tooltip>
              ),
            },
          ]}
          rowClassName="cursorPointer"
          // style={{ overflow: 'auto' }}
          // onRow={(row) => {
          //   return {
          //     onClick: () => !!row?.$permissions?.view && navigate(`${row.uid}`),
          //   };
          // }}
          loading={isCatalogLimitsLoading}
          scroll={{ x: true }}
          pagination={{
            current: current,
            pageSize: pageSize,
            total: catalogLimits?.total,
            showQuickJumper: true,
            showSizeChanger: true,
            position: ['bottomCenter'],
            onChange: (newPage, newSize) => {
              setPagination(newPage, newSize);
            },
            showTotal: (total, range) => `${range[0]}-${range[1]} ${commonT.t('paginationOf')} ${total}`,
          }}
        />
      </Paper>
    </Layout>
  );
};
